import { render, staticRenderFns } from "./marmic-services-display-panel.vue?vue&type=template&id=1fd318ca&scoped=true&lang=pug"
import script from "./marmic-services-display-panel.vue?vue&type=script&lang=js"
export * from "./marmic-services-display-panel.vue?vue&type=script&lang=js"
import style0 from "./marmic-services-display-panel.vue?vue&type=style&index=0&id=1fd318ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd318ca",
  null
  
)

export default component.exports